import {inject, Injectable} from '@angular/core';
import {CompoApiService, PortalMe} from 'compob2b-libs';
import {Observable, of} from 'rxjs';
import {catchError, map, shareReplay} from 'rxjs/operators';

/** Текущий пользователь портала (`GET /portal-users/me`): роль для топбара, профиль, куратор. */
@Injectable({providedIn: 'root'})
export class PortalMeService {
  private readonly api = inject(CompoApiService);
  private cached$: Observable<PortalMe | null> | null = null;

  /** Один запрос на сессию; ошибка (аноним, менеджер под покупателем) — `null`, экраны работают без роли. */
  me(): Observable<PortalMe | null> {
    if (!this.cached$) {
      this.cached$ = this.api.get<PortalMe>('/portal-users/me').pipe(
        map(response => response.data ?? null),
        catchError(() => of(null)),
        shareReplay({bufferSize: 1, refCount: false}),
      );
    }
    return this.cached$;
  }

  /** После правки профиля. */
  reset(): void {
    this.cached$ = null;
  }

  update(body: Pick<PortalMe, 'lastName' | 'firstName' | 'middleName' | 'phone'>): Observable<PortalMe> {
    return this.api.patch<typeof body, PortalMe>('/portal-users/me', body).pipe(map(response => response.data));
  }
}
